module.exports = __webpack_public_path__ + "img/why-2.ef71679e.png";